const channelKeys = {
    all: () => ['channels'],
    byKey: (channelKey: string) => ['channels', channelKey],
};

export default channelKeys;
